import React, { FC } from 'react'
import { Field, InjectedFormProps, reduxForm } from 'redux-form'
import { Button, Col, Form, Row } from 'antd'
import { useTranslation } from 'react-i18next'

// atoms
import InputField from '../../../atoms/InputField'

// interfaces
import { ILoginForm } from '../../../types/interfaces'

// utils
import { FORM } from '../../../utils/enums'

// validate
// eslint-disable-next-line import/no-cycle
import validate from './validateLoginForm'
import InputPasswordField from '../../../atoms/InputPasswordField'

type Props = InjectedFormProps<ILoginForm>

const LoginForm: FC<Props> = (props) => {
	const [t] = useTranslation()
	const { handleSubmit, submitting } = props

	return (
		<Form layout={'vertical'} className={'login-form'} onSubmitCapture={handleSubmit}>
			<Row justify={'center'} className={'w-full'}>
				<Col span={24}>
					<h2 className={'font-normal font-h2 text-gray-900'}>{t('loc:Login to Paradigma Formbuilder')}</h2>
				</Col>
			</Row>
			<Row justify={'center'} className={'mt-2 w-full loginInputs'}>
				<Col span={24}>
					<Field component={InputField} label={t('loc:Meno')} placeholder={t('loc:Zadajte login')} name={'username'} size={'large'} required />
					<Field
						component={InputPasswordField}
						label={t('loc:Heslo')}
						placeholder={t('loc:Your password')}
						type={'password'}
						name={'password'}
						size={'large'}
						required
					/>
					<Button size={'large'} block type={'primary'} htmlType={'submit'} disabled={submitting} loading={submitting}>
						{t('loc:Prihlásiť sa')}
					</Button>
				</Col>
			</Row>
		</Form>
	)
}

const form = reduxForm<ILoginForm>({
	form: FORM.LOGIN,
	forceUnregisterOnUnmount: true,
	touchOnChange: true,
	destroyOnUnmount: true,
	validate
})(LoginForm)

export default form
